import {useEffect, useRef} from 'react';

export function createSizeHandler(element, setMainContainerHeight, setMainContainerWidth, props){
  return function(){
      if (element.current){
        setMainContainerHeight(element.current.clientHeight);
        setMainContainerWidth(element.current.clientWidth);
        if (props.reportHeight){
          props.reportHeight(element.current.clientHeight);
        }
      }
    }

}

export function createSizeEffect(element, mainContainerHeight, setMainContainerHeight, setMainContainerWidth, props){
  if (element.current){
    setMainContainerHeight(element.current.clientHeight);
    setMainContainerWidth(element.current.clientWidth);
    if (props.reportHeight){
      props.reportHeight(element.current.clientHeight);
    }
  }  
}


// Hook
export function useEventListener(eventName, handler, element = window){
  // Create a ref that stores handler
  const savedHandler = useRef();
  
  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      // Make sure element supports addEventListener
      // On 
      const isSupported = element && element.addEventListener;
      if (!isSupported) return;
      
      // Create event listener that calls handler function stored in ref
      const eventListener = event => savedHandler.current(event);
      
      // Add event listener
      element.addEventListener(eventName, eventListener);
      
      // Remove event listener on cleanup
      return () => {
        element.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element] // Re-run if eventName or element changes
  );
};

// export function updateDimensions2(clientHeight, clientWidth, setMainContainerHeight, setMainContainerWidth, whichItem, reportHeight) {

//   return function(){
  
//     if (setMainContainerWidth){
//       var width = 0;
//       if (clientWidth){
//         width =clientWidth;
//       }
//       setMainContainerWidth(width);
//     }
//     if (setMainContainerHeight){
//       var height = 0;
//       if (clientHeight){
//         height = clientHeight;
//       }
//       setMainContainerHeight(height);
//     }

//     if (!whichItem){
//       whichItem = 0;
//     }

//     if (reportHeight && clientHeight){
//       reportHeight(clientHeight, whichItem);
//     }

//   }  
//  }

export function updateSubsetDimensions(setArrayOfHeights){
  return function(newHeight){
    setArrayOfHeights(newHeight);
  }
}
